import focusedElementHighlighter from './focused-element-highlighter';
import selectedElementHighlighter from './selected-element-highlighter';

export default {
  focusedElementHighlighter,
  selectedElementHighlighter,
};
